import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconChartBar: React.FC<Props> = ({
  width = 18,
  height = 18,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.125 16.5C17.125 16.845 16.845 17.125 16.5 17.125H1.5C1.155 17.125 0.875 16.845 0.875 16.5C0.875 16.155 1.155 15.875 1.5 15.875H16.5C16.845 15.875 17.125 16.155 17.125 16.5ZM6.70833 12.75V2.75C6.70833 1.57583 7.40917 0.875 8.58333 0.875H9.41667C10.5908 0.875 11.2917 1.57583 11.2917 2.75V12.75C11.2917 13.9242 10.5908 14.625 9.41667 14.625H8.58333C7.40917 14.625 6.70833 13.9242 6.70833 12.75ZM7.95833 12.75C7.95833 13.2408 8.0925 13.375 8.58333 13.375H9.41667C9.9075 13.375 10.0417 13.2408 10.0417 12.75V2.75C10.0417 2.25917 9.9075 2.125 9.41667 2.125H8.58333C8.0925 2.125 7.95833 2.25917 7.95833 2.75V12.75ZM17.125 6.08333V12.75C17.125 13.9242 16.4242 14.625 15.25 14.625H14.4167C13.2425 14.625 12.5417 13.9242 12.5417 12.75V6.08333C12.5417 4.90917 13.2425 4.20833 14.4167 4.20833H15.25C16.4242 4.20833 17.125 4.90917 17.125 6.08333ZM15.875 6.08333C15.875 5.5925 15.7408 5.45833 15.25 5.45833H14.4167C13.9258 5.45833 13.7917 5.5925 13.7917 6.08333V12.75C13.7917 13.2408 13.9258 13.375 14.4167 13.375H15.25C15.7408 13.375 15.875 13.2408 15.875 12.75V6.08333ZM0.875 12.75V8.58333C0.875 7.40917 1.57583 6.70833 2.75 6.70833H3.58333C4.7575 6.70833 5.45833 7.40917 5.45833 8.58333V12.75C5.45833 13.9242 4.7575 14.625 3.58333 14.625H2.75C1.57583 14.625 0.875 13.9242 0.875 12.75ZM2.125 12.75C2.125 13.2408 2.25917 13.375 2.75 13.375H3.58333C4.07417 13.375 4.20833 13.2408 4.20833 12.75V8.58333C4.20833 8.0925 4.07417 7.95833 3.58333 7.95833H2.75C2.25917 7.95833 2.125 8.0925 2.125 8.58333V12.75Z"
      fill={color}
    />
  </svg>
);

export default IconChartBar;
